import { Typography } from '@pankod/refine-antd';
import { ActivityLog } from 'services/activity-log';
import { capitalize, getDateRangeOfLastXMonths } from './shared';

const formatDate = new Intl.DateTimeFormat('en', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});

export const getActivityHistoryUrl = (module: string) => {
  const searchParams = new URL(document.location.toString()).searchParams;
  const [startDate, endDate] = getDateRangeOfLastXMonths(1);

  searchParams.set('startDate', formatDate.format(startDate).split('/').join('-'));
  searchParams.set('endDate', formatDate.format(endDate).split('/').join('-'));
  searchParams.set('actionModule', `${module}:create,${module}:update,${module}:delete`);

  return `/activity-history?${searchParams.toString()}`;
};

export const getActivityMessages = (log: ActivityLog) => {
  const { data, action } = log;

  if (action === 'create') {
    return [<Typography.Text>Created.</Typography.Text>];
  }

  if (action === 'delete') {
    return [<Typography.Text>Deleted.</Typography.Text>];
  }

  if (action === 'update' && !!data) {
    const keys = Object.keys(data);
    return keys.reduce((messages, key) => {
      const { from, to } = data[key];

      if (typeof from === 'string' && from === '' && to !== '') {
        messages.push(
          <Typography.Text>
            {capitalize(key)} added <strong>{JSON.stringify(to)}</strong>.
          </Typography.Text>
        );
        return messages;
      }
      if (typeof from === 'string' && !!from && to === '') {
        messages.push(<Typography.Text>{capitalize(key)} removed.</Typography.Text>);
        return messages;
      }

      if (Array.isArray(from) && from.length === 0 && to.length !== 0 && to[0] instanceof Object) {
        messages.push(
          <Typography.Text>
            {capitalize(key)} added <strong>{JSON.stringify(to)}</strong>.
          </Typography.Text>
        );
        return messages;
      }
      if (
        Array.isArray(from) &&
        from.length === 0 &&
        to.length !== 0 &&
        typeof to[0] === 'string'
      ) {
        messages.push(
          <Typography.Text>
            {capitalize(key)} added <strong>{JSON.stringify(to.join(', '))}</strong>.
          </Typography.Text>
        );
        return messages;
      }
      if (Array.isArray(from) && !!from.length && to.length === 0) {
        messages.push(<Typography.Text>{capitalize(key)} removed.</Typography.Text>);
        return messages;
      }
      if (Array.isArray(from) && Array.isArray(to)) {
        messages.push(
          <Typography.Text>
            {capitalize(key)} changed from <strong>{from.join(', ')}</strong> to{' '}
            <strong>{to.join(', ')}</strong>.
          </Typography.Text>
        );
        return messages;
      }

      if (
        from instanceof Object &&
        Object.keys(from).length === 0 &&
        Object.keys(to).length !== 0
      ) {
        messages.push(
          <Typography.Text>
            {capitalize(key)} added <strong>{JSON.stringify(to)}</strong>.
          </Typography.Text>
        );
        return messages;
      }
      if (from instanceof Object && !!Object.keys(from).length && Object.keys(to).length === 0) {
        messages.push(<Typography.Text>{capitalize(key)} removed.</Typography.Text>);
        return messages;
      }

      if (from === null && to !== null) {
        messages.push(
          <Typography.Text>
            {capitalize(key)} added <strong>{JSON.stringify(to)}</strong>.
          </Typography.Text>
        );
        return messages;
      }
      if (!!from && to === null) {
        messages.push(<Typography.Text>{capitalize(key)} removed.</Typography.Text>);
        return messages;
      }

      messages.push(
        <Typography.Text>
          {capitalize(key)} changed from <strong>{JSON.stringify(from)}</strong> to{' '}
          <strong>{JSON.stringify(to)}</strong>.
        </Typography.Text>
      );
      return messages;
    }, [] as React.ReactNode[]);
  }

  return [];
};
